import { connect } from 'react-redux';

import { SessionSiteSelectors } from '~selectors/SessionInfoSelectors';

import { AppState } from '../../../app/state/AppState';
import { MapStateToProps } from '../../../app/utils/ConnectUtils';
import { DetailedDatasourceThumbnail, DetailedDatasourceThumbnailStateProps } from './DetailedDatasourceThumbnail';

const mapStateToProps: MapStateToProps<DetailedDatasourceThumbnailStateProps> = (state: AppState) => {
  return {
    siteEARMode: SessionSiteSelectors.extractEncryptionMode(state)
  };
};

export const ConnectedDetailedDatasourceThumbnail = connect(mapStateToProps)(DetailedDatasourceThumbnail);
